import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useApplicationContext } from '../../../../../../Context/applicationContext';
import { hasShowRule, isVisible, hasEnableRule, isEnabled, getScopeKeys } from '../../../../../KenApplication/ruleHelper';
import KenWidget from '../KenWidget';

function KenFieldContent(props) {
  const { rule, metaData, options, fieldValidation } = props;
  // If rule is present
  const { getValues, watch, unregister } = useFormContext();
  const disabledProps = hasEnableRule(props) ? { disabled: !isEnabled(props.rule, {}, getValues) } : {};

  // if options are to are dynamic
  const [extras, setExtras] = useState({});
  const [extrasDate, setExtrasDate] = useState({});

  const {
    applicationState: { formOptions = {}, activeStep },
  } = useApplicationContext();

  const watchFields = watch(getScopeKeys(rule));
  const ruleValues = useMemo(() => getRuleVaues(watchFields, rule, getValues), [watchFields, rule]);

  let optionKeyGetValue;
  if (metaData?.optionsKeyGet) {
    optionKeyGetValue = watch(metaData?.optionsKeyGet);
  }

  let watchValidationFields;
  if (fieldValidation) {
    watchValidationFields = watch(fieldValidation?.scope);
  }

  function calculateYearMonthDifference(date, extra = 0) {
    const targetDate = new Date(date);
    const currentDate = new Date();
    let yearDifference = currentDate.getFullYear() - targetDate.getFullYear();
    let monthDifference = currentDate.getMonth() - targetDate.getMonth();
    if (monthDifference < 0) {
      yearDifference -= 1;
      monthDifference += 12;
    }
    const totalDifference = (yearDifference === 0 ? yearDifference + 1 : yearDifference) + monthDifference / 12;
    return parseFloat(totalDifference.toFixed(2)) + extra;
  }

  // Dynamic options values
  useEffect(() => {
    if (metaData?.optionsKey) {
      const addedOptions = formOptions[metaData?.optionsKey] || [];
      setExtras({
        options: [...options, ...addedOptions],
        extraProps: true,
      });
    }
    if (metaData?.optionsKeyGet && optionKeyGetValue) {
      const addedOptions = formOptions[optionKeyGetValue] || [];
      setExtras({
        options: [...options, ...addedOptions],
        extraProps: true,
      });
    }
  }, [metaData, options, formOptions, optionKeyGetValue]);

  useEffect(() => {
    if (fieldValidation?.value === 'GREATER') {
      setExtrasDate({
        ...extras,
        extraProps: true,
        minDate: typeof watchValidationFields === 'string' ? (fieldValidation?.format === 'date' ? watchValidationFields : calculateYearMonthDifference(watchValidationFields, fieldValidation?.extra)) : props?.minDate,
      });
    } else {
      setExtrasDate({
        ...extras,
        extraProps: true,
        maxDate: typeof watchValidationFields === 'string' ? (fieldValidation?.format === 'date' ? watchValidationFields : -calculateYearMonthDifference(watchValidationFields, fieldValidation?.extra)) : props?.maxDate,
      });
    }
  }, [watchValidationFields]);

  useEffect(() => {
    if (ruleValues?.isVisible === false) {
      if (activeStep && activeStep !== 0) {
        if(props?.name != 'applicant[thirdLanguage]') {
          unregister(props?.name);
        }
      }
    }
  }, [ruleValues?.isVisible === false]);

  return <>{hasShowRule(props) ? ruleValues.isVisible && <KenWidget {...props} {...extras} {...extrasDate} /> : <KenWidget {...props} {...disabledProps} {...extras} {...extrasDate} />}</>;
}

const getRuleVaues = function (watchFields, rule, getValues) {
  if (rule && getScopeKeys(rule)?.length > 0) {
    return {
      isVisible: isVisible(rule, {}, getValues),
    };
  }

  return {};
};

export default KenFieldContent;
